/** Payment Element fonts and borders aligned with `el-input`. */

export const stripeElementsFontCssSrc =
  'https://fonts.cdnfonts.com/css/rawline'

export const stripeElementsFontFamily = 'Rawline, sans-serif'

export const elementThemeInput = {
  border: '1px solid #cdcdcf',
  borderColorHover: '#686970',
  borderColorFocus: '#000000',
} as const

export const adaptivePricingToggle = {
  unselectedTextColor: '#686970',
  selectedBorderColor: '#1C1A49',
  selectedTextColor: '#000000',
} as const

export function stripePaymentElementAppearance(inputBorderRadius: string) {
  return {
    theme: 'stripe' as const,
    variables: {
      fontFamily: stripeElementsFontFamily,
      colorText: '#000000',
      focusOutline: 'none',
      focusBoxShadow: 'none',
    },
    rules: {
      '.Label': {
        color: '#000000',
      },
      '.Input': {
        borderRadius: inputBorderRadius,
        border: elementThemeInput.border,
        boxShadow: 'none',
      },
      '.Input:hover': {
        borderColor: elementThemeInput.borderColorHover,
      },
      '.Input:focus': {
        borderColor: elementThemeInput.borderColorFocus,
        outline: 'none',
        boxShadow: 'none',
      },
      '.ToggleItem': {
        borderRadius: inputBorderRadius,
        border: elementThemeInput.border,
        boxShadow: 'none',
        color: adaptivePricingToggle.unselectedTextColor,
      },
      '.ToggleItem--selected': {
        border: `1.5px solid ${adaptivePricingToggle.selectedBorderColor}`,
        color: adaptivePricingToggle.selectedTextColor,
        boxShadow: 'none',
      },
    },
  }
}
